<template>
  <section id="tac-admin-sales-order" class="tac-admin-sales-order tac-admin-sales-order__list">
    <div class="page-header">
      <h1 class="page-header-title">
        <router-link :to="{name: 'admin/sales-order/browse'}" class="page-header__title-link--no-highlight">
          <span class="fa fa-fw fa-th"></span> Sales Order
        </router-link>
        <small>List</small>
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner">
          <div class="form-group form-group-sm">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData || isFormClear()" @click="search">Search</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData || (isFormClear() && isFilterClear() && isSorterClear())" @click="clear">Clear</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group form-group-sm">
            <div class="btn-toolbar">
              <div class="btn-group btn-group-sm">
                <a :href="linkToNewRecord()" class="btn btn-default">New</a>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" @click="reload" title="Refresh Page" :disabled="fetchingData"><i class="fa fa-fw fa-refresh"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form class="form" @submit.prevent="search">
      <div class="row">
        <div class="col-lg-2">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-4">Number</label>
              <div class="col-lg-8">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.number" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-4">Amount</label>
              <div class="col-lg-8">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.amount" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-4">Company</label>
              <div class="col-lg-8">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.company" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-4">Last Name</label>
              <div class="col-lg-8">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.lastName" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-4">Telephone</label>
              <div class="col-lg-8">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.telephone" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-4">First Name</label>
              <div class="col-lg-8">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.firstName" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-3">Email</label>
              <div class="col-lg-9">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.email" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-3">ZIP</label>
              <div class="col-lg-9">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.zip" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-1">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label sr-only">Serial #</label>
              <div class="col-lg-12">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.serial" placeholder="Serial #" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label sr-only">PO #</label>
              <div class="col-lg-12">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.purchaseOrder" placeholder="PO #" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <button type="submit" class="sr-only">Submit</button>
    </form>
    <div class="row">
      <div class="col-lg-9">
        <div class="panel panel-default">
          <table class="table table-bordered table-striped table-hover table-condensed">
            <thead>
              <tr>
                <th style="width: 10rem;" class="text-center" @click="toggleSort('sortNumber')">
                  <sorter-icon :order="getSortMethod('sortNumber')"></sorter-icon>
                  Order
                </th>
                <th @click="toggleSort('sortCustomerName')">
                  <sorter-icon :order="getSortMethod('sortCustomerName')"></sorter-icon>
                  Customer
                </th>
                <th style="width: 15rem;" class="text-right" @click="toggleSort('sortAmount')">
                  <sorter-icon :order="getSortMethod('sortAmount')"></sorter-icon>
                  Order Total
                </th>
                <th style="width: 15rem;" class="text-center" @click="toggleSort('sortDate')">
                  <sorter-icon :order="getSortMethod('sortDate')"></sorter-icon>
                  Order Date
                </th>
                <th style="width: 40rem;" @click="toggleSort('sortStatus')">
                  <sorter-icon :order="getSortMethod('sortStatus')"></sorter-icon>
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!orders.length">
                <td class="text-center text-warning" colspan="8">
                  No order found.  Try a different search parameter.
                </td>
              </tr>
              <tr
                v-for="(order, key) in orders"
                :key="key"
                :class="{warning: isItemSelected(order)}"
                @click="handleItemClick($event, order)"
              >
                <td class="text-center">
                  <a :href="linkToOrder(order)" @click.stop target="_blank" title="Click to open order record on new tab or page">
                    <i class="fa fa-fw fa-external-link"></i>
                  </a>
                  <a :href="linkToOrder(order)" @click.stop>{{ order.orderNumber }}</a>
                </td>
                <td>
                  <a :href="linkToCustomer(order)" @click.stop target="_blank" title="Click to open customer record on new tab or page">
                    <i class="fa fa-fw fa-external-link"></i>
                  </a>
                  <a :href="linkToCustomer(order)" @click.stop>{{ order.customer.company || order.customer.name }}</a>
                </td>
                <td class="text-right"><money :value="order.amount"></money></td>
                <td class="text-center">{{ order.transactionDate | format('MM/DD/YYYY hh:mma') }}</td>
                <td>{{ statusCodeToLabel(order.status) }}</td>
              </tr>
            </tbody>
            <tfoot v-if="!!orders.length">
              <tr>
                <td colspan="8">
                  <pagination
                    class="text-center pagination-compact"
                    :p-total="pagination.total"
                    :p-per-page="pagination.perPage"
                    :p-page="pagination.page"
                    :p-show-total="true"
                    :p-show-per-page="true"
                    :p-edit-per-page="true"
                    @open-page="openPage"
                    @per-page-change="updatePerPage($event)"
                    >
                  </pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="panel panel-default">
          <div class="panel-heading">
            <template v-if="isOneItemSelected">
            <strong>[{{ lastSelectedItemNumber }}]&nbsp;&nbsp;{{ lastSelectedItemDate }}</strong>
            </template>
            <template v-else>
            Filter
            </template>
          </div>
          <div class="panel-body">
            <div class="form">
              <div class="form-horizontal">
                <div class="form-group form-group-sm">
                  <label class="control-label col-lg-4">Status</label>
                  <div class="col-lg-8">
                    <select :disabled="fetchingData" class="form-control" v-model="filter.status" @change="search">
                      <option :value="null">All</option>
                      <option v-for="(opt, key) in statusOptions" :key="key" :value="opt.id">{{ opt.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group form-group-sm">
                  <label class="control-label col-lg-4">Deleted</label>
                  <div class="col-lg-8">
                    <select :disabled="fetchingData" class="form-control" v-model="filter.discarded" @change="search">
                      <option :value="null">All</option>
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div><!-- .panel -->
      </div><!-- .col-* -->
    </div><!-- .row -->
  </section>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapState, mapGetters } from 'vuex'
import { format } from '@/plugin/filter/date'
import MixinApiResponse from '@/plugin/mixin/api-response'
import MixinMoney from '@/plugin/mixin/money'
import MixinPagination from '@/plugin/mixin/pagination';
import Money from '@/plugin/element/money'
import Pagination from '@/plugin/bootstrap/pagination';
import SorterIcon from '@/plugin/element/sorter-icon'

const FORM_MODEL = {
  number        : null,
  amount        : null,
  company       : null,
  firstName     : null,
  lastName      : null,
  telephone     : null,
  email         : null,
  zip           : null,
  serial        : null,
  purchaseOrder : null,
}

const FILTER_MODEL = {
  status    : null,
  discarded : null
}

const SORTER_MODEL = {
  sortNumber       : null,
  sortCustomerName : null,
  sortAmount       : null,
  sortDate         : null,
  sortStatus       : null,
}

const PAGINATION_PER_PAGE = 'vue.admin.sales.order.pagination.per-page'

export default {
  name: 'list',
  data() {
    return {
      form     : _.cloneDeep(FORM_MODEL),
      filter   : _.cloneDeep(FILTER_MODEL),
      sorter   : _.cloneDeep(SORTER_MODEL),
      selected : {items: []},
    }
  },
  created() {
    this.$alertify.dismissAll()

    this.loadFromRoute()
    this.fetchData()
  },
  watch: {
    $route() {
      this.loadFromRoute()
      this.fetchData()
    },
    sorter() {
      this.search()
    },
    orders: {
      deep: true,
      handler() {
        if (1 !== this.totalItems || 1 != this.pagination.total || !this.autoOpen) {
          return
        }
        this.openRecord(_.first(this.orders))
      }
    }
  },
  computed: {
    ...mapState('sales/order/orders', {
      orders: 'items',
      pagination: 'pagination',
      fetchingData: 'requested',
    }),
    ...mapGetters('sales/order/orders', {
      currencySign: 'currencySign',
      statusOptions: 'statusOptions',
    }),
    isAnyItemSelected() {
      return this.selected.items.length > 0
    },
    isOneItemSelected() {
      return this.selected.items.length === 1
    },
    isMultipleItemsSelected() {
      return this.selected.items.length > 1
    },
    lastSelectedItemNumber() {
      return this.lastSelectedItem.orderNumber
    },
    lastSelectedItemDate() {
      return moment(this.lastSelectedItem.transactionDate, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm:ssa')
    },
    lastSelectedItem() {
      return _.last(this.selected.items)
    },
    totalItems() {
      return (this.orders || []).length
    },
    autoOpen() {
      return !_.has(this.$route, 'query.autoOpen')
        || '1' === _.get(this.$route, 'query.autoOpen')
    }
  },
  methods: {
    updatePerPage(val) {
      if (val) {
        window.localStorage.setItem(PAGINATION_PER_PAGE, val)
      } else {
        window.localStorage.removeItem(PAGINATION_PER_PAGE)
      }

      this.$store.dispatch('sales/order/orders/changePerPage', val)
      this.changeRoutePerPage(val)
      this.fetchData()
    },
    openPage(page) {
      this.$store.dispatch('sales/order/orders/changePage', page)
      this.changeRoutePage(page)
      this.fetchData()
    },
    reload() {
      this.fetchData()
    },
    fetchData() {
      this.$store.dispatch('sales/order/orders/updateFilter', this.compileFilters())
      this.$store.dispatch('sales/order/orders/updateSorter', this.compileSorters())

      this.$store.dispatch('sales/order/orders/changePage', this.PGM_getRoutePage())
      this.$store.dispatch('sales/order/orders/changePerPage', this.PGM_getRoutePerPage())

      this.$store.dispatch('sales/order/orders/fetch')
    },
    openRecord(order) {
      window.location.href = this.linkToOrder(order)
    },
    linkToOrder(order) {
      return `/admin/sales_order.php?oID=${order.orderNumber}&action=view`
    },
    linkToNewRecord() {
      return `/admin/sales_order.php?action=new`
    },
    linkToCustomer(order) {
      return `/admin/customers.php?cID=${order.customer.id}&action=new`
    },
    search() {
      if (this.fetchingData) {
        return
      }

      let query = this.createSearchQuery()
      if (query.page) {
        delete query.page
      }

      this.$router.push({
        name   : 'admin/sales-order/browse',
        params : _.cloneDeep(this.$route.params),
        query  : _.cloneDeep(query),
      })
    },
    clear() {
      this.clearForm()
      this.clearFilter()
      this.clearSorter()
    },
    clearForm() {
      if (this.fetchingData) {
        return
      }

      this.form = Object.assign({}, FORM_MODEL)

      let query = this.createSearchQuery()

      this.$router.push({
        name   : 'admin/sales-order/browse',
        params : _.cloneDeep(this.$route.params),
        query  : query,
      })
    },
    clearFilter() {
      if (this.fetchingData) {
        return
      }

      this.filter = Object.assign({}, FILTER_MODEL)

      let query = this.createSearchQuery()

      this.$router.push({
        name   : 'admin/sales-order/browse',
        params : _.cloneDeep(this.$route.params),
        query  : query,
      })
    },
    clearSorter() {
      if (this.fetchingData) {
        return
      }

      this.sorter = Object.assign({}, SORTER_MODEL)

      let query = this.createSearchQuery()

      this.$router.push({
        name   : 'admin/sales-order/browse',
        params : _.cloneDeep(this.$route.params),
        query  : query,
      })
    },
    createSearchQuery() {
      let query = _.chain(this.$route.query)
        .cloneDeep()
        .omit(_.keys(FORM_MODEL))
        .omit(_.keys(FILTER_MODEL))
        .omit(_.keys(SORTER_MODEL))
        .omit(['t', 'autoOpen'])
        .value()

      if (!this.isFormClear()) {
        const form = _.pickBy(this.form, (field) => {
          return !_.isEmpty(field)
        })
        query = Object.assign({}, query, form)
      }

      if (!this.isFilterClear()) {
        const filter = _.pickBy(this.filter, (field) => {
          return !_.isEmpty(field)
        })
        query = Object.assign({}, query, filter)
      }

      if (!this.isSorterClear()) {
        const sorter = _.pickBy(this.sorter, (field) => {
          return !_.isEmpty(field)
        })
        query = Object.assign({}, query, sorter)
      }

      query.t = new Date().getTime()

      return query
    },
    compileFilters() {
      let filters = {}

      if (!this.isFormClear()) {
        const form = _.pickBy(this.form, (field) => {
          return !_.isEmpty(field)
        })
        filters = Object.assign({}, filters, form)
      }
      if (!this.isFilterClear()) {
        const filter = _.pickBy(this.filter, (field) => {
          return !_.isEmpty(field)
        })
        filters = Object.assign({}, filters, filter)
      }

      return filters
    },
    compileSorters() {
      let sorters = {}

      if (!this.isSorterClear()) {
        const sorter = _.pickBy(this.sorter, (field) => {
          return !_.isEmpty(field)
        })
        sorters = Object.assign({}, sorters, sorter)
      }

      return sorters
    },
    isFormClear() {
      return !_.get(this.form, 'number')
        && !_.get(this.form, 'amount')
        && !_.get(this.form, 'company')
        && !_.get(this.form, 'firstName')
        && !_.get(this.form, 'lastName')
        && !_.get(this.form, 'telephone')
        && !_.get(this.form, 'email')
        && !_.get(this.form, 'zip')
        && !_.get(this.form, 'serial')
        && !_.get(this.form, 'purchaseOrder')
    },
    isFilterClear() {
      return _.isEqual(this.filter, FILTER_MODEL)
        || (
          !_.get(this.filter, 'method')
          && !_.get(this.filter, 'status')
          && !_.get(this.filter, 'discarded')
          && !_.isEqual(this.filter, FILTER_MODEL)
        )
    },
    isSorterClear() {
      return _.isEqual(this.sorter, SORTER_MODEL)
        || (
          !_.get(this.sorter, 'sortNumber')
          && !_.get(this.sorter, 'sortCustomerName')
          && !_.get(this.sorter, 'sortAmount')
          && !_.get(this.sorter, 'sortDate')
          && !_.get(this.sorter, 'sortStatus')
          && !_.isEqual(this.sorter, SORTER_MODEL)
        )
    },
    loadFromRoute() {
      this.form   = _.chain(this.$route).get('query', {}).cloneDeep().pick(_.keys(FORM_MODEL)).value()
      this.filter = _.chain(this.$route).get('query', {}).cloneDeep().pick(_.keys(FILTER_MODEL)).thru(val => Object.assign({}, FILTER_MODEL, val)).value()
      this.sorter = _.chain(this.$route).get('query', {}).cloneDeep().pick(_.keys(SORTER_MODEL)).thru(val => Object.assign({}, SORTER_MODEL, val)).value()
    },
    statusCodeToLabel(code) {
      if ('pending' === code) {
        return 'Pending'
      }
      if ('open' === code) {
        return 'Open'
      }
      if ('closed' === code) {
        return 'Closed'
      }
      return code
    },
    toggleSort(col) {
      let val = this.sorter[col]

      if ('asc' === val) {
        val = 'desc'
      } else  {
        val = 'asc'
      }

      this.sorter = {}

      this.$set(this.sorter, col, val)
    },
    getSortMethod(col) {
      return this.sorter[col]
    },
    handleItemClick(e, item) {
      if (!e.ctrlKey && this.isItemSelected(item)) {
        this.openRecord(item)
      } else {
        this.selectItem(e, item)
      }
    },
    selectItem(e, item) {
      if (e.ctrlKey) {
        const match = _.find(this.selected.items, item)
        const idx = match ? _.indexOf(this.selected.items, match) : -1
        if (idx === -1) {
          this.selected.items.push(item)
        } else {
          this.selected.items.splice(idx, 1)
        }
      } else {
        this.selected.items.splice(0, this.selected.items.length)
        this.selected.items.push(item)
      }
    },
    isItemSelected(item) {
      const match = _
        .chain(this.selected.items)
        .find((selected) => {
          return selected.orderNumber === item.orderNumber
        })
        .value()

      return undefined !== match
    }
  },
  components: {
    Money,
    Pagination,
    SorterIcon
  },
  filters: {
    format
  },
  mixins: [
    MixinApiResponse,
    MixinMoney,
    MixinPagination
  ]
}
</script>
